"use client"

import { type ComponentType, type ForwardRefExoticComponent, type ReactNode } from "react"
import type { WidgetType } from "../Widgets/registry"
import { PlatformUIKitContext } from "./PlatformUIKitContext"

/**
 * Shared context for all Platform UI Kit components - wrap your app in this
 * provider to use Platform UI Kit components.
 *
 * It's pretty thin right now, we only use it to hold onto the component you
 * use for rendering Links, but it could be expanded in the future.
 */
export function PlatformUIKitProvider({
  children,
  linkComponent = "a",
  allowedWidgetTypes = "GA",
  radixPortalContainer,
  hydrationSafe = false,
}: {
  children: ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  linkComponent?: ComponentType<any> | ForwardRefExoticComponent<any> | "a"
  allowedWidgetTypes?: WidgetType[] | "ALL" | "GA"
  radixPortalContainer?: HTMLElement
  hydrationSafe?: boolean
}) {
  return (
    <PlatformUIKitContext.Provider
      value={{
        linkComponent,
        allowedWidgetTypes,
        radixPortalContainer,
        hydrationSafe,
      }}
    >
      {children}
    </PlatformUIKitContext.Provider>
  )
}
